import { NotificationModel } from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { NotificationState } from '@app/finxone-web-frontend/app/lib/state/notifications.state';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

export const profileCTAsValidationMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
  ) => Observable<boolean>
> = new Map<ButtonActionType, any>([
  [
    ButtonActionType.MARK_ALL_NOTIFICATIONS_AS_READ,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri: UiZoneWidgetAttributeConfig) => {
      const data = store.select(NotificationState.getNotification);
      return data.subscribe({
        next: (res) => {
          const key: string = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: hasUnreadNotifications(res.notificationList),
          });
        },
      });
    },
  ],
]);

function hasUnreadNotifications(notificationList: NotificationModel[]): boolean {
  return notificationList.some((notification) => notification.read === false);
}
